import React, { useMemo } from 'react';
import useBreakpointSelector from '../useBreakpointSelector';
var GridContext = /*#__PURE__*/React.createContext(undefined);
export function useGridState() {
  return React.useContext(GridContext);
}

/**
 * A component for managing and providing grid state (via context) without
 * actually rendering a grid. You can use this to render composite grids that
 * consist of multiple subgrids which will all get their state from this
 * provider.
 */
export default function GridProvider(_ref) {
  var breakpoints = _ref.breakpoints,
      children = _ref.children,
      defaultBreakpoint = _ref.defaultBreakpoint;
  var breakpoint = useBreakpointSelector(breakpoints, defaultBreakpoint);
  var state = useMemo(() => ({
    breakpoint,
    breakpoints
  }), [breakpoint, breakpoints]);
  return /*#__PURE__*/React.createElement(GridContext.Provider, {
    value: state
  }, children);
}
GridProvider.Context = GridContext;